import gql from 'graphql-tag'

export default gql`
query registrations($sort: SortFindManyRegistrationInput, $filter: FilterFindManyRegistrationInput, $limit: Int, $skip: Int){
registrations (sort: $sort, filter: $filter, limit: $limit, skip: $skip) {
    _id
    code
    status
    expired
    expireAt
    eventId
    testMode
    createdAt
    messages {
      _id
      registrationId
      text
      type
      createdAt
    }
    amount {
      total
      discount
      discounted
    }
    payment {
      _id
      payAmount
    }
    event {
      _id
      slug
      isRegOpen
      regClosed
      extraProductCount
      settings {
        _id
        registration {
          _id
          maxOrders
        }
        virtualRun {
          _id
          distanceMode
          noEcer
          period {
            start
            end
          }
        }
        ticket {
          _id
          hideNumber
        }
      }
      name {
        en
        th
        zh
      }
      periods {
        _id
        start
        end
        preRegisterStart
        preRegisterEnd
      }
    }
    participants {
      _id
      profile {
        _id
        firstName
        lastName
      }
      tickets {
        _id
        kind
        reservedNumber
        number
        eventCode
        productTypeId
        eventId
        registrationId
        participantId
        nameOnBib
        couponCodeText
        couponCodeId
        shirtTypeId
        shirtId
        delivery
        trackingCode
        deliveryCarrier
        deliverTo {
          recipient
          street
          locality
          city
          region
          postalCode
        }
        couponCode {
          _id
          code
          couponCodeType {
            _id
            ticketTypeIds
            name {
              en
              th
              zh
            }
            discount
          }
        }
        ticketType {
          _id
          shirtEnabled
          finisherShirtEnabled
          quantity
          name {
            en
            th
            zh
          }
          settings {
            _id
            virtualRun {
              _id
              distanceMode
              noEcer
              period {
                start
                end
              }
            }
          }
          participantFields {
            _id
            name
            enabled
            required
            extraMessage {
              en
              th
              zh
            }
            validations {
              _id
              type
              params
              message {
                en
                th
                zh
              }
            }
          }
          virtualBib {
            _id
            backgroundUrl
            fonts {
              _id
              fontFamily
              fontSrcUrl
            }
            numberStyle {
              _id
              font
              textAlign
              fillStyle
              top
              left
            }
            nameStyle {
              _id
              font
              textAlign
              fillStyle
              top
              left
            }
          }
          race {
            _id
            distance
            distanceUnit
            startTime
            ageCategoryDiff
            name {
              en
              th
              zh
            }
            ageRangeStrict {
              male {
                min
                max
              }
              female {
                min
                max
              }
            }
            ageCategories {
              min
              max
              gender
              _id
            }
            settings {
              _id
              virtualRun {
                _id
                distanceMode
                noEcer
                period {
                  start
                  end
                }
              }
            }
          }
          races {
            _id
            name {
              en
              th
              zh
            }
            settings {
              _id
              virtualRun {
                _id
                distanceMode
                noEcer
                period {
                  start
                  end
                }
              }
            }
          }
        }
        options (sort: ORDER_ASC) {
          _id
          value
          order
          itemId
          itemIds
          questionId
          question {
            _id
            kind
            order
            name {
              en
              th
              zh
            }
            items {
              _id
              imageUrl
              value {
                en
                th
                zh
              }
            }
          }
        }
      }
      runs {
        _id
        distance
        donationAmount
        eventId
        ticketItemId
        participantId
        userId
        raceId
        runnerImage {
          _id
          original {
            url
            _id
            size {
              width
              height
            }
          }
          thumbnail {
            url
            _id
            size {
              width
              height
            }
          }
        }
        activityImage {
          _id
          original {
            url
            _id
            size {
              width
              height
            }
          }
          thumbnail {
            url
            _id
            size {
              width
              height
            }
          }
        }
      }
    }
    orders {
      _id
      code
      status
      expireAt
    }
    successfulPayment {
      _id
      amount
      method
    }
    registrationType {
      _id
      name {
        en
        th
        zh
      }
      lotto {
        enabled
      }
    }
  }
}

`



// WEBPACK FOOTER //
// ./src/graphql/queries/registrations.js